export const transformPayInMethodDto = _ref => {
  let {
    id,
    note,
    code,
    icon,
    enabled,
    preferred,
    translated_name,
    event_tracking_code,
    requires_credit_card,
    method_change_possible
  } = _ref;
  return {
    id,
    code,
    icon,
    enabled,
    preferred,
    note: note || null,
    translatedName: translated_name,
    eventTrackingCode: event_tracking_code,
    requiresCreditCard: requires_credit_card,
    methodChangePossible: method_change_possible
  };
};
export const transformPayInMethodDtos = payInMethods => payInMethods.map(transformPayInMethodDto);